import { render, staticRenderFns } from "./TwitterPostTable.vue?vue&type=template&id=496eaa0a&scoped=true"
import script from "./TwitterPostTable.vue?vue&type=script&lang=ts"
export * from "./TwitterPostTable.vue?vue&type=script&lang=ts"
import style0 from "./TwitterPostTable.vue?vue&type=style&index=0&id=496eaa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496eaa0a",
  null
  
)

export default component.exports